import RegisteredCouponRs, { RegisteredCouponDto } from '@domain/rs/coupons/RegisteredCouponRs';
import { CouponType } from '@domain/constant/coupons/couponType';
import DateUtil from '@utils/date/util';
import DateFormat from '@utils/date/format';

export default class RegisteredCouponListVO {
  count: number;
  hasVaildCoupons: boolean;
  registeredCoupons: RegisteredCouponVO[];

  constructor(rs: RegisteredCouponRs) {
    this.count = rs.count;
    this.hasVaildCoupons = this.checkValidCoupons(rs);
    this.registeredCoupons = rs.registeredCoupons.map((coupon) => new RegisteredCouponVO(coupon));
  }

  private checkValidCoupons(rs: RegisteredCouponRs) {
    return rs.registeredCoupons.some(({ isExpired }) => !isExpired);
  }
}

export class RegisteredCouponVO {
  code: string;
  expiresDateTime: string;
  expireDateTimeText: string;
  isExpired: boolean;
  registeredDateTime: string;
  couponType: CouponType;

  constructor(dto: RegisteredCouponDto) {
    this.code = dto.code;
    this.expiresDateTime = dto.expiresDateTime;
    this.expireDateTimeText = this.getExpireDateTimeText(dto.expiresDateTime);
    this.isExpired = dto.isExpired;
    this.registeredDateTime = dto.registeredDateTime;
    this.couponType = dto.couponType;
  }

  private getExpireDateTimeText(expiresDateTime: string) {
    return DateUtil.isPastDate(new Date(expiresDateTime))
      ? '기간 만료'
      : DateFormat.format(new Date(expiresDateTime), 'yyyy.MM.dd (week) HH:mm 만료');
  }
}
